/* eslint-disable no-unused-vars */
import { Box, MenuItem, Tooltip } from '@mui/material'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { LiaSaveSolid } from 'react-icons/lia'
import { RxCross2 } from 'react-icons/rx'
import { Button } from 'src/Common/ui/button'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import MultiSelectInputDisable from 'src/Common/ui/MultiSelectDisable'
import { MULTI_DEPARTMENTS_KEY } from 'src/Entities/Governance'
import { useRiskStore } from '../Store/RiskStore'
import * as Endpoints from '../../../Entities/EndPoints'
import { FILTER_APPROACH, FILTER_CATEGORY, FILTER_IDENTIFIED_ON, FILTER_IMPACTED_DEPARTMENT, FILTER_RISK_LEVEL, FILTER_RISK_OWNER, FILTER_SOURCE_OF_RISK, FILTER_STATUS, FILTER_TYPE } from 'src/Entities/RiskTypes'
import { cn, formatDateParts } from 'src/lib/utils'
import ResetIcon from 'src/Common/ui/resetIcon'
import Axios from 'src/Axios'
import { RESOLUTION_APPROACH } from 'src/Entities/IssueTypes'
import { useIssueStore } from 'src/Containers/IssueRegister/store/IssueStore'

export default function RiskHistoryFilter ({ editState, type = 'RISK', toggleDraw }) {
    const instance = Axios.getInstance()

    const [ riskTypes, setRiskTypes ] = useState([])
    const [ allCategories, setAllCategories ] = useState([])
    const [ impactedDepartments, setImpactedDepartments ] = useState([])
    const [ AllMeasures, setAllMeasures ] = useState([])
    const [ allStatus, setAllStatus ] = useState([])
    const [ allRiskOwner, setAllRiskOwner ] = useState([])
    const [ allRiskLevels, setAllRiskLevels ] = useState([])
    const [ allSources, setAllSources ] = useState([])
    const { clearRiskFilterData, getIssueHistoryFilter } = useRiskStore()

    useEffect(() => {
        const fetchRiskTypes = async () => {
            try {
                const types = await getAllRiskTypes()
                setRiskTypes(types)
            } catch (error) {
                console.error('Error fetching risk types:', error)
            }
            try {
                const types = await getAllCategories()
                setAllCategories(types)
            } catch (error) {
                console.error('Error fetching all categories:', error)
            }
            try {
                const types = await getAllDepartments()
                setImpactedDepartments(types)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
            try {
                let types = null
                if (type === 'ISSUE') {
                    types = await getAllIssueMeasures()
                } else {
                    types = await getAllMeasures()
                }
                setAllMeasures(types)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
            try {
                const types = await getAllStatus()
                if (!typeCond()) {
                    setAllStatus(types.map((ele) => {
                        if (!typeCond()) {
                            ele.disable = true
                        }
                        return ele
                    }).filter(ele => ele.id === 7))
                    setRiskFilter(prevstate => (
                        {
                            ...prevstate,
                            status: [{
                                id: 7,
                                name: 'Closed'
                            }]
                        }
                    ))
                } else {
                    setAllStatus(types)
                }
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
            try {
                const types = await getAllRiskOwner()
                setAllRiskOwner(types)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
            try {
                let types = null
                if (typeCond()) {
                    types = await getAllSources()
                } else {
                    types = [
                        {
                            id: 1,
                            name: 'New',
                            value: 1,
                            status: 1
                        },
                        {
                            id: 2,
                            name: 'Risk',
                            value: 2,
                            status: 1
                        }
                    ]
                }
                setAllSources(types)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
            try {
                let types = null
                if (typeCond()) {
                    types = await getAllRiskLevels(orgId)
                } else {
                    types = await getAllIssueLevels(orgId)
                }
                setAllRiskLevels(types.map((item, index) => {
                    return {
                        id: index + 1,
                        name: item
                    }
                }))
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
        }

        fetchRiskTypes()
    }, [])
    useEffect(() => {
        if (editState.right) {
            setRiskFilter({
                identifiedOn: null,
                status: !typeCond()
                    ? [{
                        id: 7,
                        name: 'Closed',
                        disable: true
                    }]
                    : [],
                riskLevel: [],
                sourceOfRisk: [],
                types: [],
                category: [],
                approach: [],
                riskOwner: [],
                impactedDepartment: []
            })
        }
    }, [location.pathname])
    const { getRiskHistoryFilter } = useRiskStore()
    const [ riskFilter, setRiskFilter ] = useState({
        identifiedOn: null,
        status: [],
        riskLevel: [],
        sourceOfRisk: [],
        types: [],
        category: [],
        approach: [],
        riskOwner: [],
        impactedDepartment: []
    })

    const orgId = localStorage.getItem('orgId')
    const getAllRiskTypes = async () => {
        if (typeCond()) {
            try {
                const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllRiskTypes')
                return response.data
            } catch (error) {
                console.error('Error fetching risk types:', error)
                throw error
            }
        } else {
            try {
                const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllIssueTypes')
                return response.data
            } catch (error) {
                console.error('Error fetching risk types:', error)
                throw error
            }
        }
    }
    const getAllCategories = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllCategories')
            return response.data
        } catch (error) {
            console.error('Error fetching all categories:', error)
            throw error
        }
    }
    const getAllDepartments = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + `/user/GetDepatmentsByOrganization?organizationId=${orgId}`)
            return response.data
        } catch (error) {
            console.error('Error fetching departments:', error)
            throw error
        }
    }
    const getAllMeasures = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllMeasures')
            return response.data
        } catch (error) {
            console.error('Error fetching measures:', error)
            throw error
        }
    }
    const getAllIssueMeasures = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllIssueApproach')
            return response.data
        } catch (error) {
            console.error('Error fetching measures:', error)
            throw error
        }
    }
    const getAllStatus = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/risk/GetRiskHistoryStatus')
            return response.data
        } catch (error) {
            console.error('Error fetching status:', error)
            throw error
        }
    }
    const getAllRiskLevels = async (orgId) => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/risk/GetAllRiskLevels?orgId=' + orgId)
            return response.data
        } catch (error) {
            console.error('Error fetching risk levels:', error)
            throw error
        }
    }
    const getAllIssueLevels = async (orgId) => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/issue/GetAllIssueLevels?orgId=' + orgId)
            return response.data
        } catch (error) {
            console.error('Error fetching risk levels:', error)
            throw error
        }
    }
    const getAllSources = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllSources')
            return response.data
        } catch (error) {
            console.error('Error fetching sources:', error)
            throw error
        }
    }
    const getAllRiskOwner = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + `/user/GetDepatmentsByOrganization?organizationId=${orgId}`)
            return response.data
        } catch (error) {
            console.error('Error fetching risk owner:', error)
            throw error
        }
    }

    const onValueChange = (key, value) => {
        setRiskFilter(prevState => ({
            ...prevState, [key]: value
        }))
    }
    const onValueSelectChange = (value, name, data) => {
        setRiskFilter(prevState => ({
            ...prevState,
            [name]: data?.map((item) => {
                if (value.includes(item.id)) {
                    return {
                        id: item.id,
                        name: item.name
                    }
                } else {
                    return null
                }
            }).filter(el => el)
        }))
    }
    const loginId = localStorage.getItem('userId')
    const onSubmit = (filterData) => {
        const finalData = {}
        // finalData.approach = [ 1, 2, 3, 4 ]
        Object.keys(filterData).map((item, index) => {
            if (item === FILTER_IDENTIFIED_ON && filterData[item] !== null) {
                finalData[item] = filterData[item]
            }
            if (filterData[item]?.length > 0) {
                if (item === FILTER_RISK_LEVEL) {
                    finalData[item] = filterData[item].map(ele => ele.name)
                } else {
                    finalData[item] = filterData[item].map(ele => ele.id)
                }
            }

            return item
        })

        if (typeCond()) {
            getRiskHistoryFilter(loginId, finalData)
        } else {
            // finalData.sourceOfIssue = finalData.sourceOfRisk
            // delete finalData.sourceOfRisk
            getIssueHistoryFilter(loginId, finalData)
        }
        toggleDraw('right', false)
    }
    const handleChipDelete = (key, value) => {
        setRiskFilter(prevState => ({
            ...prevState,
            [key]: key === FILTER_IDENTIFIED_ON
                ? value
                : prevState[key]?.map((item) => {
                    if (value !== item.id) {
                        return {
                            id: item.id,
                            name: item.name
                        }
                    } else {
                        return null
                    }
                }).filter(el => el)
        }))
    }
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, setError, control, trigger } = useForm({})
    const clearAll = () => {
        setRiskFilter({
            identifiedOn: null,
            status: !typeCond()
                ? [{
                    id: 7,
                    name: 'Closed',
                    disable: true
                }]
                : [],
            riskLevel: [],
            sourceOfRisk: [],
            types: [],
            category: [],
            approach: [],
            riskOwner: [],
            impactedDepartment: []
        })
    }
    const typeCond = () => {
        return type === 'RISK'
    }
    return (
        <>
            <div className='overflow-auto h-[90%]'>

                <div className='p-4 flex gap-5 mb-2 border-b-[1px] flex-wrap'>
                    {
                        Object.keys(riskFilter).map((ele) => {
                            return (
                                <>
                                    {
                                        ele === FILTER_IDENTIFIED_ON
                                            ? <>{ riskFilter[ele] !== null && <div onClick={() => handleChipDelete(ele, null)} className='text-primary text-b4 font-semibold rounded-sm px-3 py-[2px] bg-[hsl(var(--primary-table-head))]'>
                                                {formatDateParts(riskFilter[ele])?.datePart}<span className='cursor-pointer' style={{ color: 'red', fontSize: '12px' }}>{' ' + 'x'}</span>
                                            </div>}</>
                                            : riskFilter[ele].map((item, index) => (
                                                <div key={index} onClick={() => handleChipDelete(ele, item.id)} className={cn(ele === 'status' && !typeCond() && 'pointer-events-none opacity-[0.5]', '!text-primary text-b4 font-semibold rounded-sm px-3 py-[2px] bg-[hsl(var(--primary-table-head))]')}>
                                                    {item.name}<span className='cursor-pointer' style={{ color: 'red', fontSize: '12px' }}>{' ' + 'x'}</span>
                                                </div>
                                            ))
                                    }
                                </>
                            )
                        })
                    }
                    { Object.keys(riskFilter)?.some((ele) => (ele === 'identifiedOn' && riskFilter[ele]) || riskFilter[ele]?.length > 0) && <div className='flex justify-between items-center cursor-pointer'>
                        <Tooltip title="Reset" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div><ResetIcon color={'hsl(var(--primary))'} size={20} onClick={clearAll}/></div>
                        </Tooltip>
                    </div>}
                </div>
                <div className='pt-3'>

                    <Box display="grid" gridTemplateColumns="repeat(2, minmax(150px, 1fr))" gap={2}>
                        <Box gridColumn="span 1">
                            <div style={{ marginBottom: '2%', paddingRight: '12px', paddingLeft: '4px' }}>
                                <DatePickerInput
                                    control={control}
                                    name='IdentifiedOn'
                                    maxDate={new Date()}
                                    label={t('Identified On')}
                                    register={register}
                                    type="text"
                                    value={riskFilter?.identifiedOn || ''}
                                    onValueChange={(event) => onValueChange(FILTER_IDENTIFIED_ON, event)}
                                />
                            </div>
                        </Box>
                        <Box gridColumn="span 1" sx={{ pb: 4, pl: 1 }}>
                            <MultiSelectInputDisable label={t('Status')} control={control} name="status" placeholder={t('Select Status')} defaultValue={riskFilter?.status?.map(ele => ele?.id)} value={riskFilter?.status?.map(ele => ele?.id)} options={allStatus?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status, disable: data?.disable }))}
                                onValueChange={(value) => {
                                    onValueSelectChange(value, FILTER_STATUS, allStatus)
                                }} />
                        </Box>
                    </Box>
                    <Box display="grid" gridTemplateColumns="repeat(2, minmax(150px, 1fr))" gap={2}>
                        <Box gridColumn="span 1" sx={{ pb: 4, pl: 1 }}>
                            <MultiSelectInputDisable label={t(typeCond() ? 'Risk Level' : 'Issue Level')} control={control} name="deparments" placeholder={t('Select Department')} defaultValue={riskFilter?.riskLevel?.map(ele => ele?.id)} value={riskFilter?.riskLevel?.map(ele => ele?.id)} options={allRiskLevels?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                onValueChange={(value) => {
                                    onValueSelectChange(value, FILTER_RISK_LEVEL, allRiskLevels)
                                }} />
                        </Box>
                        <Box gridColumn="span 1" sx={{ pb: 4, pl: 1 }}>
                            <MultiSelectInputDisable label={t(typeCond() ? 'Source Of Risk' : 'Source of Issue')} control={control} name="deparments" placeholder={t(typeCond() ? 'Select Source Of Risk' : 'Select Source Of Issue')} defaultValue={riskFilter?.sourceOfRisk?.map(ele => ele?.id)} value={riskFilter?.sourceOfRisk?.map(ele => ele?.id)} options={allSources?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                onValueChange={(value) => {
                                    onValueSelectChange(value, FILTER_SOURCE_OF_RISK, allSources)
                                }} />
                        </Box>
                    </Box>
                    <Box display="grid" gridTemplateColumns="repeat(2, minmax(150px, 1fr))" gap={2}>
                        <Box gridColumn="span 1" sx={{ pb: 4, pl: 1 }}>
                            <MultiSelectInputDisable label={t(typeCond() ? 'Risk Nature' : 'Issue Types')} control={control} name="Type" placeholder={t(typeCond() ? 'Select Risk Nature' : 'Select Issue Nature')} defaultValue={riskFilter?.types?.map(ele => ele?.id)} value={riskFilter?.types?.map(ele => ele?.id)} options={riskTypes?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                onValueChange={(value) => {
                                    onValueSelectChange(value, FILTER_TYPE, riskTypes)
                                }} />
                        </Box>
                        <Box gridColumn="span 1" sx={{ pb: 4, pl: 1 }}>
                            <MultiSelectInputDisable label={t('Impacted Department')} control={control} name="impacted departments" placeholder={t('Select Impacted Department')} defaultValue={riskFilter?.impactedDepartment?.map(ele => ele?.id)} value={riskFilter?.impactedDepartment?.map(ele => ele?.id)} options={impactedDepartments?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                onValueChange={(value) => {
                                    onValueSelectChange(value, FILTER_IMPACTED_DEPARTMENT, impactedDepartments)
                                }} />
                        </Box>

                    </Box>
                    <Box display="grid" gridTemplateColumns="repeat(2, minmax(150px, 1fr))" gap={2}>
                        <Box gridColumn="span 1" sx={{ pb: 4, pl: 1 }}>
                            <MultiSelectInputDisable label={t('Approach')} control={control} name="deparments" placeholder={t('Select Approach')} defaultValue={riskFilter?.approach?.map(ele => ele?.id)} value={riskFilter?.approach?.map(ele => ele?.id)} options={AllMeasures?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                onValueChange={(value) => {
                                    onValueSelectChange(value, FILTER_APPROACH, AllMeasures)
                                }} />
                        </Box>
                        <Box gridColumn="span 1" sx={{ pb: 4, pl: 1 }}>
                            <MultiSelectInputDisable label={t(typeCond() ? 'Risk Owner' : 'Issue Owner')} control={control} name="deparments" placeholder={t('Select Department')} defaultValue={riskFilter?.riskOwner?.map(ele => ele?.id)} value={riskFilter?.riskOwner?.map(ele => ele?.id)} options={allRiskOwner?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                onValueChange={(value) => {
                                    onValueSelectChange(value, FILTER_RISK_OWNER, allRiskOwner)
                                }} />
                        </Box>
                    </Box>
                    <Box display="grid" gridTemplateColumns="repeat(2, minmax(150px, 1fr))" gap={2}>
                        { typeCond() && <Box gridColumn="span 1" sx={{ pb: 4, pl: 1 }}>
                            <MultiSelectInputDisable label={t('Category')} control={control} name="category" placeholder={t('Select Category')} defaultValue={riskFilter?.category?.map(ele => ele?.id)} value={riskFilter?.category?.map(ele => ele?.id)} options={allCategories?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                onValueChange={(value) => {
                                    onValueSelectChange(value, FILTER_CATEGORY, allCategories)
                                }} />
                        </Box>}
                    </Box>
                </div>
            </div>

            <div className='h-[10%] bg-card flex justify-end items-center w-full'>
                <div className="flex space-x-4">
                    <Button
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                        onClick={() => {
                            toggleDraw('right', false)
                            onSubmit({
                                identifiedOn: null,
                                status: [],
                                riskLevel: [],
                                sourceOfRisk: [],
                                types: [],
                                category: [],
                                approach: [],
                                riskOwner: [],
                                impactedDepartment: []
                            })
                            clearAll()
                            // clearRiskFilterData()
                        }}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button onClick={() => onSubmit(riskFilter)} >
                        {t('Apply')}
                    </Button>
                </div>
            </div>

        </>
    )
}
